
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/* console.log(
  'Ny version av JavaScript laddad - Timestamp:',
  new Date().toISOString()
); */ var $d7c25b879120eee3$exports = {};
$d7c25b879120eee3$exports = JSON.parse('[{"code":"dt057g","coursename":"Webbutveckling I","progression":"A","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT057G/"},{"code":"dt084g","coursename":"Introduktion till programmering i JavaScript","progression":"A","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT084G/"},{"code":"dt200g","coursename":"Grafisk teknik f\xf6r webb","progression":"A","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT200G/"},{"code":"dt068g","coursename":"Webbanv\xe4ndbarhet","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT068G/"},{"code":"dt003g","coursename":"Databaser","progression":"A","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT003G/"},{"code":"dt211g","coursename":"Frontend-baserad webbutveckling","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT211G/"},{"code":"dt207g","coursename":"Backend-baserad webbutveckling","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT207G/"},{"code":"dt208g","coursename":"Programmering i TypeScript","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT208G/"},{"code":"ik060g","coursename":"Projektledning","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/IK060G/"},{"code":"dt071g","coursename":"Programmering i C#.net","progression":"A","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT071G/"},{"code":"dt193g","coursename":"Fullstacks-utveckling med ramverk","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT193G/"},{"code":"dt209g","coursename":"Webbutveckling f\xf6r WordPress","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT209G/"},{"code":"dt191g","coursename":"Webbutveckling med .NET","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT191G/"},{"code":"dt210g","coursename":"F\xf6rdjupad frontend-utveckling","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT210G/"},{"code":"dt140g","coursename":"Sj\xe4lvst\xe4ndigt arbete","progression":"B","syllabus":"https://www.miun.se/utbildning/kursplaner-och-utbildningsplaner/DT140G/"}]');


document.addEventListener('DOMContentLoaded', function() {
    const hamburgerMenu = document.querySelector('.hamburger-menu');
    const nav = document.querySelector('.nav');
    if (!hamburgerMenu || !nav) {
        console.error('Hamburger-meny eller navigationsmeny saknas i DOM!');
        return;
    }
    // Toggle huvudmenyn vid klick på hamburgermenyn
    hamburgerMenu.addEventListener('click', function(event) {
        event.stopPropagation(); // Förhindra att klick bubbla upp
        nav.classList.toggle('active');
    });
    // Stäng menyn vid klick utanför
    document.addEventListener('click', function(event) {
        if (!hamburgerMenu.contains(event.target) && !nav.contains(event.target)) closeMenu();
    });
    // Funktion för att stänga menyn
    function closeMenu() {
        nav.classList.remove('active');
    }
});
// Variabler
let $cba3eb2abed8e80a$var$courses = [];
let $cba3eb2abed8e80a$var$filteredCourses = [];
let $cba3eb2abed8e80a$var$lastFilteredOrder = []; // Sparar senaste filtrerade ordningen
let $cba3eb2abed8e80a$var$currentSortColumn = null;
let $cba3eb2abed8e80a$var$sortStates = {};
let $cba3eb2abed8e80a$var$debounceTimer;
async function $cba3eb2abed8e80a$var$fetchCourses() {
    const apiUrl = 'https://webbutveckling.miun.se/files/ramschema_ht24.json';
    try {
        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error(`HTTP-fel! Status: ${response.status}`);
        $cba3eb2abed8e80a$var$courses = await response.json();
        console.log("Kurser h\xe4mtade fr\xe5n API:", $cba3eb2abed8e80a$var$courses);
    } catch (error) {
        console.warn('API misslyckades, laddar lokal JSON:', error);
        $cba3eb2abed8e80a$var$courses = (0, (/*@__PURE__*/$parcel$interopDefault($d7c25b879120eee3$exports))); // Använd lokala JSON-data
    }
    $cba3eb2abed8e80a$var$displayCourses($cba3eb2abed8e80a$var$courses);
}
$cba3eb2abed8e80a$var$fetchCourses();
// *Debounce-för att vänta innan sökning sker
function $cba3eb2abed8e80a$var$debounce(func, delay) {
    return function(...args) {
        clearTimeout($cba3eb2abed8e80a$var$debounceTimer);
        $cba3eb2abed8e80a$var$debounceTimer = setTimeout(()=>func(...args), delay);
    };
}
// Visar kurser i tabellen
function $cba3eb2abed8e80a$var$displayCourses(data) {
    let tableBody = document.getElementById('table-body');
    let activeElement = document.activeElement; // Spara aktivt element
    let rows = data.map((course)=>`<tr>
      <td>${course.code}</td>
      <td>${course.coursename}</td>
      <td>${course.progression}</td>
    </tr>`).join('');
    tableBody.innerHTML = ''; // Rensa innehållet innan ny inladdning
    setTimeout(()=>{
        tableBody.innerHTML = rows;
        $cba3eb2abed8e80a$var$updateStatus(data.length);
        // Återställ fokus om det var på sökrutan
        if (activeElement && activeElement.id === 'search') activeElement.focus();
    }, 10);
}
// Filtrera kurser endast vid Enter-tangent
document.getElementById('search').addEventListener('keydown', function(event) {
    if (event.key === 'Enter') {
        // Kontrollera om Enter trycks
        event.preventDefault();
        $cba3eb2abed8e80a$var$filterCourses();
    }
});
// Gör att "Sök"-knappen kör samma funktion som Enter-knappen
document.getElementById('search-button').addEventListener('click', function() {
    /* console.log('Sök-knappen klickad');  */ // För debugging
    $cba3eb2abed8e80a$var$filterCourses();
});
// Anropa debounce vid varje inmatning
document.getElementById('search').addEventListener('input', $cba3eb2abed8e80a$var$debounce(()=>{
    let searchField = document.getElementById('search');
    $cba3eb2abed8e80a$var$filterCourses();
    searchField.focus(); // Behåller fokus i sökrutan
}, 1000));
// Sorteringsfunktion (asc - desc - default)
function $cba3eb2abed8e80a$var$sortCourses(columnIndex) {
    let headers = document.querySelectorAll('th');
    /* console.log(`Sortering klickad på kolumn ${columnIndex}`); */ // Återställ den gamla sorteringen när klick på ny kolumn
    if ($cba3eb2abed8e80a$var$currentSortColumn !== columnIndex) {
        if ($cba3eb2abed8e80a$var$currentSortColumn !== null) $cba3eb2abed8e80a$var$sortStates[$cba3eb2abed8e80a$var$currentSortColumn] = 'default';
        $cba3eb2abed8e80a$var$currentSortColumn = columnIndex;
    }
    // asc - desc - default
    if (!$cba3eb2abed8e80a$var$sortStates[columnIndex] || $cba3eb2abed8e80a$var$sortStates[columnIndex] === 'default') $cba3eb2abed8e80a$var$sortStates[columnIndex] = 'asc';
    else if ($cba3eb2abed8e80a$var$sortStates[columnIndex] === 'asc') $cba3eb2abed8e80a$var$sortStates[columnIndex] = 'desc';
    else $cba3eb2abed8e80a$var$sortStates[columnIndex] = 'default';
    /* console.log(
    `Sorteringsläge för kolumn ${columnIndex}: ${sortStates[columnIndex]}`
  ); */ // Ta bort alla sorteringspilar och "active"-klasser
    headers.forEach((th)=>{
        th.removeAttribute('data-sort');
        th.classList.remove('active');
    });
    // Om "default" - Återställ listan till filtrerad ordning och ta bort pil
    if ($cba3eb2abed8e80a$var$sortStates[columnIndex] === 'default') {
        /* console.log(`Återställer till senaste filtreringsordningen`); */ $cba3eb2abed8e80a$var$currentSortColumn = null;
        $cba3eb2abed8e80a$var$displayCourses($cba3eb2abed8e80a$var$lastFilteredOrder);
        return;
    }
    // Bestäm sorteringsriktning o uppdatera UI
    let sortDirection = $cba3eb2abed8e80a$var$sortStates[columnIndex] === 'asc' ? 1 : -1;
    headers[columnIndex].setAttribute('data-sort', $cba3eb2abed8e80a$var$sortStates[columnIndex]);
    headers[columnIndex].classList.add('active');
    /* console.log(`Sorterar ${sortStates[columnIndex]} ordning`); */ // Sortera kurserna
    $cba3eb2abed8e80a$var$filteredCourses.sort((a, b)=>{
        let key = columnIndex === 0 ? 'code' : columnIndex === 1 ? 'coursename' : 'progression';
        let textA = a[key].toLowerCase();
        let textB = b[key].toLowerCase();
        return textA.localeCompare(textB) * sortDirection;
    });
    $cba3eb2abed8e80a$var$displayCourses($cba3eb2abed8e80a$var$filteredCourses);
}
// Filtreringsfunktion
function $cba3eb2abed8e80a$var$filterCourses() {
    let searchQuery = document.getElementById('search').value.toLowerCase();
    /* console.log(`Söker efter: "${searchQuery}"`); */ $cba3eb2abed8e80a$var$filteredCourses = $cba3eb2abed8e80a$var$courses.filter((course)=>course.code.toLowerCase().includes(searchQuery) || course.coursename.toLowerCase().includes(searchQuery));
    /* console.log(
    `Filtrering klar. Antal kurser som matchar: ${filteredCourses.length}`
  ); */ $cba3eb2abed8e80a$var$lastFilteredOrder = [
        ...$cba3eb2abed8e80a$var$filteredCourses
    ]; // Spara filtreringsordning för default
    $cba3eb2abed8e80a$var$updateStatus($cba3eb2abed8e80a$var$filteredCourses.length);
    if ($cba3eb2abed8e80a$var$currentSortColumn !== null) /* console.log(`Sortering kvarstår för kolumn ${currentSortColumn}`); */ $cba3eb2abed8e80a$var$sortCourses($cba3eb2abed8e80a$var$currentSortColumn);
    else /* console.log('Inga aktiva sorteringar, visar filtrerade kurser'); */ $cba3eb2abed8e80a$var$displayCourses($cba3eb2abed8e80a$var$filteredCourses);
}
// Uppdatera antal kurser
$cba3eb2abed8e80a$var$updateStatus($cba3eb2abed8e80a$var$filteredCourses.length);
// Rensa sökning och sortering
document.getElementById('clear-search').addEventListener('click', function() {
    /* console.log('Rensning av sökning och sortering initierad...'); */ document.getElementById('search').value = ''; // Rensa sökfältet
    $cba3eb2abed8e80a$var$filteredCourses = [
        ...$cba3eb2abed8e80a$var$courses
    ]; // Återställ tabellen till alla kurser
    $cba3eb2abed8e80a$var$lastFilteredOrder = [
        ...$cba3eb2abed8e80a$var$filteredCourses
    ]; // Återställ defaultvärde
    /* console.log('Tabell återställd till originalinläsning'); */ // Återställ sorteringsstatus
    $cba3eb2abed8e80a$var$sortStates = {};
    $cba3eb2abed8e80a$var$currentSortColumn = null;
    /* console.log('Alla sorteringsvärden nollställda'); */ // Ta bort ALLA sorteringspilar och "active"-klasser från kolumner
    document.querySelectorAll('th').forEach((th)=>{
        th.removeAttribute('data-sort');
        th.classList.remove('active');
    });
    /* console.log('Alla sorteringspilar och highlights borttagna'); */ // Tvinga en omritning av tabellen
    setTimeout(()=>{
        $cba3eb2abed8e80a$var$displayCourses($cba3eb2abed8e80a$var$filteredCourses);
    /* console.log('Tabell uppdaterad'); */ }, 10);
    document.getElementById('search-status').textContent = "S\xf6kningen har rensats, alla kurser visas.";
});
// Koppla sorteringsfunktion till HTML-tabellen
window.sortCourses = $cba3eb2abed8e80a$var$sortCourses;
// Kör fetch vid sidstart
$cba3eb2abed8e80a$var$fetchCourses();
function $cba3eb2abed8e80a$var$updateStatus(count) {
    let statusElement = document.getElementById('results-status');
    statusElement.textContent = `${count} courses found`;
}


//# sourceMappingURL=repo.2d1c9d7d.js.map
